import { alpha } from "@mui/material/styles";
import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Backdrop(theme: Theme): Components<Theme> {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(theme.palette.grey[900], 0.8),
        },
        invisible: {
          background: "transparent",
        },
      },
    },
  };
}
